"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHoverWithTransition = void 0;
var _useToggle = _interopRequireDefault(require("react-use/lib/useToggle"));
const useHoverWithTransition = isInitialVisible => {
  const [isVisible, setVisibility] = (0, _useToggle.default)(isInitialVisible);
  const [isTransitionActive, setTransitionActive] = (0, _useToggle.default)(false);
  const handleMouseEnterComponent = () => {
    if (!isInitialVisible) {
      setVisibility(true);
      setTransitionActive(true);
    }
  };
  const handleMouseLeaveComponent = () => {
    if (!isInitialVisible) {
      setVisibility(false);
      setTransitionActive(true);
    }
  };
  const handleTransitionEnd = () => {
    setTransitionActive(false);
  };
  return {
    onMouseEnter: handleMouseEnterComponent,
    onMouseLeave: handleMouseLeaveComponent,
    onTransitionEnd: handleTransitionEnd,
    isVisible,
    isTransitionActive,
    setVisibility
  };
};
exports.useHoverWithTransition = useHoverWithTransition;
//# sourceMappingURL=useHoverWithTransition.js.map